"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxSizeMedium = exports.BoxSizeSmall = exports.LineHeightVariants = exports.FontSizeVariants = void 0;
var styled_components_1 = require("styled-components");
var FontSizeVariants;
(function (FontSizeVariants) {
    FontSizeVariants["Bigger"] = "2.25rem";
    FontSizeVariants["Big"] = "2.25rem";
    FontSizeVariants["Medium"] = "1.5rem";
    FontSizeVariants["MediumV2"] = "1.7rem";
    FontSizeVariants["Small"] = "1rem";
})(FontSizeVariants = exports.FontSizeVariants || (exports.FontSizeVariants = {}));
var LineHeightVariants;
(function (LineHeightVariants) {
    LineHeightVariants["Big"] = "2.4375rem";
    LineHeightVariants["Medium"] = "1.8rem";
    LineHeightVariants["Small"] = "1.3rem";
})(LineHeightVariants = exports.LineHeightVariants || (exports.LineHeightVariants = {}));
var fontSizeStyle = function (type, size) {
    if (type === void 0) { type = ''; }
    if (size === void 0) { size = 'default'; }
    switch (type) {
        case 'big':
            return size === 'medium' ? FontSizeVariants.Bigger : FontSizeVariants.Big;
        case 'medium':
            return size === 'medium' ? FontSizeVariants.MediumV2 : FontSizeVariants.Medium;
        default:
            return FontSizeVariants.Small;
    }
};
var lineHeightStyle = function (type) {
    if (type === void 0) { type = ''; }
    switch (type) {
        case 'big':
            return LineHeightVariants.Big;
        case 'medium':
            return LineHeightVariants.Medium;
        default:
            return LineHeightVariants.Small;
    }
};
exports.BoxSizeSmall = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 234px;\n  height: 234px;\n\n  .headline {\n    ", "\n  }\n\n  .sub-headline {\n    ", "\n  }\n"], ["\n  width: 234px;\n  height: 234px;\n\n  .headline {\n    ",
    "\n  }\n\n  .sub-headline {\n    ",
    "\n  }\n"])), function (_a) {
    var styleSize = _a.styleSize;
    return "font-size: " + fontSizeStyle(styleSize) + "; line-height: " + lineHeightStyle(styleSize) + ";";
}, function (_a) {
    var styleSizeSubHeadline = _a.styleSizeSubHeadline;
    return "font-size: " + fontSizeStyle(styleSizeSubHeadline) + "; line-height: " + lineHeightStyle(styleSizeSubHeadline) + ";";
});
exports.BoxSizeMedium = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 258px;\n  height: 258px;\n\n  .headline {\n    ", "\n  }\n\n  .sub-headline {\n    ", "\n  }\n"], ["\n  width: 258px;\n  height: 258px;\n\n  .headline {\n    ",
    "\n  }\n\n  .sub-headline {\n    ",
    "\n  }\n"])), function (_a) {
    var styleSize = _a.styleSize;
    return "font-size: " + fontSizeStyle(styleSize, 'medium') + "; line-height: " + lineHeightStyle(styleSize) + ";";
}, function (_a) {
    var styleSizeSubHeadline = _a.styleSizeSubHeadline;
    return "font-size: " + fontSizeStyle(styleSizeSubHeadline, 'medium') + "; line-height: " + lineHeightStyle(styleSizeSubHeadline) + ";";
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=boxTypes.js.map